
/**
 * Module dependencies.
 */

import { color } from 'src/styles/utils';
import { ifProp } from 'styled-tools';
import React, { ReactElement, SyntheticEvent, useContext } from 'react';
import Switch, { ReactSwitchProps } from 'react-switch';
import styled, { ThemeContext, css } from 'styled-components';

/**
 * `EventType` type.
 */

type EventType = globalThis.MouseEvent | SyntheticEvent<globalThis.MouseEvent | KeyboardEvent, Event>;

/**
 * `Props` type.
 */

type Props = {
  'aria-label'?: string,
  checked: boolean,
  className?: string,
  disabled?: boolean,
  name?: string,
  onBlur?: () => void,
  onFocus?: () => void,
  onToggle: (checked: boolean, event: EventType, id: string) => void
};

/**
 * `StyledSwitch` styled compnent.
 */

const StyledSwitch = styled(Switch)<ReactSwitchProps>`
  ${ifProp('disabled', css`
    opacity: 0.35 !important;
  `)}
`;

/**
 * `SwitchButton` component.
 */

const SwitchButton = (props: Props): ReactElement => {
  const { onToggle, ...rest } = props;
  const theme = useContext(ThemeContext);

  return (
    <StyledSwitch
      {...rest}
      activeBoxShadow={''}
      checkedIcon={false}
      handleDiameter={16}
      height={24}
      offColor={color('green100')({ theme })}
      onChange={onToggle}
      onColor={color('brown400')({ theme })}
      uncheckedIcon={false}
      width={48}
    />
  );
};

/**
 * Export `SwitchButton` component.
 */

export default SwitchButton;
